export const salesHistoryConfig = {
    PDF_DEFAULT_TEXT: "委託販売精算書"
};